import { render, staticRenderFns } from "./userGroup.vue?vue&type=template&id=3e487377&scoped=true&"
import script from "./userGroup.vue?vue&type=script&lang=ts&"
export * from "./userGroup.vue?vue&type=script&lang=ts&"
import style0 from "./userGroup.vue?vue&type=style&index=0&id=3e487377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e487377",
  null
  
)

export default component.exports